import React from 'react';
import Chart from 'components/pure/charts/custom/Chart';
import BarSeries from 'components/pure/charts/custom/BarSeries';
import theme from 'styles/theme';
import Axis from 'components/pure/charts/custom/Axis';

export default class TrendBarChart extends React.Component {
  render() {
    const {
      data,
      barWidth,
      width,
      height,
      margins,
      scales,
      timeFormatter,
      tickValues,
      fill,
      textXAdjust,
    } = this.props;

    // value needs to be a number.
    const fixedData = data.map(d => {
      return {date: d.date, value: (isNaN(d.value) ? 0 : d.value) || 0};
    });

    const svgDimensions = {width, height};

    // -2 is the space between each of the bars
    const usedBarWidth = barWidth || (width - margins.right - margins.left) / fixedData.size - 2;

    const {xScale, yScale} = scales;

    const usedTextXAdjust = textXAdjust || usedBarWidth / 2 - 3;
    return (
      <Chart svgDimensions={svgDimensions} preserveAspectRatio={false} className="trend-bar-chart">
        <Axis
          orient={'Bottom'}
          scale={xScale}
          translate={`translate(0, ${height - margins.bottom})`}
          tickValues={tickValues}
          tickSizeInner={0}
          tickSizeOuter={0}
          tickPadding={3}
          tickFormat={timeFormatter}
          textXAdjust={usedTextXAdjust}
        />
        <BarSeries
          data={fixedData}
          scales={{xScale, yScale}}
          margins={margins}
          svgDimensions={svgDimensions}
          fill={fill || theme.palette.heather}
          barWidth={usedBarWidth}
          roundingX={2}
          roundingY={2}
          roundInPixels={2}
          placeholderForZero={1}
          tooltipContent={d => d && this.props.tooltipContent && this.props.tooltipContent(d)}
        />
      </Chart>
    );
  }
}
